const RECIPIENT_UNIT_HEADERS = [
  "Recipient Unit",
  "Recipient Unit Number",
  "Unit",
  "Unit Number",
  "Apt",
  "Suite",
];

const normalizeHeader = (header: string) =>
  header.toLowerCase().replace(/[^a-z0-9]/g, "");

/** Address Units must never be inferred from package-unit columns. */
export function readBulkRecipientUnit(row: Readonly<Record<string, unknown>>) {
  const keys = Object.keys(row);
  for (const header of RECIPIENT_UNIT_HEADERS) {
    const key = keys.includes(header)
      ? header
      : keys.find(
          (candidate) => normalizeHeader(candidate) === normalizeHeader(header)
        );
    if (key !== undefined) return String(row[key] ?? "");
  }
  return "";
}
